import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color", "url", "tagName", "iconClassName", "className", "style", "ratio", "multiColor", "customColor"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import { getSize } from "../../utils/sizeMap";
import styles from "./styles.pcss";
import { getColor } from "./utils";
var cnIcon = cnBem('icon', styles);
export var Icon = forwardRefWithTag(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    url = props.url,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'span' : _props$tagName,
    iconClassName = props.iconClassName,
    className = props.className,
    style = props.style,
    ratio = props.ratio,
    _props$multiColor = props.multiColor,
    multiColor = _props$multiColor === void 0 ? true : _props$multiColor,
    customColor = props.customColor,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  var mode = multiColor ? 'mask' : 'background';
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnIcon(null, [className]),
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, style), {}, _defineProperty({}, '--icon-size', getSize(size)), ratio === 1 ? {} : _defineProperty({}, '--icon-ratio', ratio)), multiColor ? _defineProperty({}, '--icon-color', getColor(customColor || color)) : {})
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    className: cnIcon('image', {
      mode: mode
    }, [iconClassName]),
    style: _defineProperty({}, '--icon-url', "url(".concat(url, ")"))
  }));
});